import { cn } from "../../lib/cn";

const SIZES = { sm: "size-4 border-2", md: "size-6 border-2", lg: "size-10 border-[3px]" };

/** Anel girando em `currentColor` (sc-spin .7s), igual ao loading do Button do DS. */
export function Spinner({
  size = "md",
  className,
  label = "Carregando",
}: {
  size?: keyof typeof SIZES;
  className?: string;
  label?: string;
}) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        "inline-block shrink-0 animate-spin rounded-full border-[color-mix(in_oklch,currentColor_35%,transparent)] border-t-current",
        SIZES[size],
        className,
      )}
    />
  );
}
